import {AuthModel} from './_models'

type OneRowQueueInvoiceReportAccess = Pick<AuthModel, 'OneRowQueueInvoiceReport'>

// The bulk-send report is open to every user of an installation that enables it.
export const canViewOneRowQueueInvoiceReport = (
  user?: OneRowQueueInvoiceReportAccess | null
): boolean => user?.OneRowQueueInvoiceReport === true
